'use client';

import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { AuthMutation, AuthQueryOptions, UnauthQueryOptions } from '@/api';

/** 1회 응모에 필요한 응모권 수 기본값(raffleCost 미제공 시 폴백) */
export const DEFAULT_RAFFLE_COST = 5;
export const LOTTO_STATE_QUERY_KEY = AuthQueryOptions['get:/wello/v2/auth/benefit-lottery/entry-availability']().queryKey;

//* 응모권·응모가능은 실 API(entry-availability). 누적 상금·목표금액은 useLottoPool(공동 값) 참조.
export const useLottoState = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/benefit-lottery/entry-availability"](),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useSuspenseQuery(t0);
};

//* 응모 = 리워드영상 시청 이력 저장(POST /external/adpopcorn-ssp, lottoYN=true)과 원자 처리 —
//* 별도 추첨 API 없음. 응답 context.lottery({result, wonPoint, raffleTicketCount})가 결과다.
//* 잔량·가능여부·누적 상금·포인트는 서버 권위라 무효화로 재동기화하고, invalidate Promise를
//* 반환해 refetch 완료까지 isPending을 유지한다(결과 다이얼로그가 신선한 캐시를 읽게).
export const useLottoDraw = () => {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthMutation["post:/wello/v2/auth/external/adpopcorn-ssp"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient) {
    t1 = {
      ...t0,
      onSuccess: () => Promise.all([queryClient.invalidateQueries({
        queryKey: LOTTO_STATE_QUERY_KEY
      }), queryClient.invalidateQueries({
        queryKey: UnauthQueryOptions["get:/wello/v2/allows/benefit-lottery/pool"]().queryKey
      }), queryClient.invalidateQueries({
        queryKey: AuthQueryOptions["get:/wello/v2/auth/point"]().queryKey
      })])
    };
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
function _temp(data) {
  const appliedTicketCount = data?.context?.raffleTicketCount ?? 0;
  const requiredTicketCount = data?.context?.raffleCost ?? DEFAULT_RAFFLE_COST;
  return {
    appliedTicketCount,
    requiredTicketCount,
    canApply: data?.context?.entryAvailableYn ?? false
  };
}